import { locations } from "../endpoints/locations.endpoints";
import $axios from "../http/accessor";

const LocationService = {
  getAll: (page: number, count: number) => {
    return $axios.get(locations.get_all, {
      params: {
        page,
        count,
      },
    });
  },

  countries: (page: number, count: number) => {
    return $axios.get(locations.countries, {
      params: {
        page,
        count,
      },
    });
  },

  cities: (id: number, page: number, count: number) => {
    return $axios.get(locations.cities(id), {
      params: {
        page,
        count,
      },
    });
  },

  getById: (id: number) => {
    return $axios.get(locations.get_by_id(id));
  },
  create: (data: FormData) => {
    return $axios.post(locations.create, data);
  },

  update: (id: number, data: FormData) => {
    return $axios.put(locations.update(id), data);
  },

  delete: (id: number) => {
    return $axios.delete(locations.delete(id));
  },
};

export default LocationService;
